document.addEventListener('DOMContentLoaded', function() {
  const tabLinks = document.querySelectorAll('.hdt-account-nav-link a[data-tab]');
  const sections = document.querySelectorAll('.hdt-account-section');
  function showTab(tabName) {
    // Hide all sections
    sections.forEach(section => {
      section.style.display = 'none';
    });
    
    document.querySelectorAll('.hdt-account-nav-link').forEach(item => {
      item.classList.remove('is--active');
    });
    
    // Show selected section
    const selectedSection = document.getElementById(tabName + '-content');
    if (selectedSection) {
      selectedSection.style.display = 'block';
    }
    
    // Add active class to selected nav item
    const activeLink = document.querySelector(`a[data-tab="${tabName}"]`);
    if (activeLink) {
      activeLink.closest('.hdt-account-nav-link').classList.add('is--active');
    }
  }
  // Add click event to each tab link
  tabLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const tabName = this.getAttribute('data-tab');
      showTab(tabName);
      
      // Update URL hash
      window.location.hash = tabName;
    });
  });
  
  // Check for hash on page load
  if (window.location.hash) {
    const tabName = window.location.hash.substring(1);
    showTab(tabName);
  } else {
    // Show dashboard by default
    document.getElementById('dashboard-content').style.display = 'block';
  }
  
  // Copy coupon code functionality
  document.addEventListener('click', function(e) {
    if (e.target.textContent === 'Copy Code') {
      const couponCode = e.target.closest('.coupon-details').querySelector('.coupon-code strong').textContent;
      navigator.clipboard.writeText(couponCode).then(function() {
        e.target.textContent = 'Copied!';
        setTimeout(function() {
          e.target.textContent = 'Copy Code';
        }, 2000);
      });
    }
  });
});
// Delete address function
function deleteAddress(addressId) {
  if (confirm('Are you sure you want to delete this address?')) {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/account/addresses/' + addressId;
    
    const hiddenMethod = document.createElement('input');
    hiddenMethod.type = 'hidden';
    hiddenMethod.name = '_method';
    hiddenMethod.value = 'delete';
    form.appendChild(hiddenMethod);
    
    document.body.appendChild(form);
    form.submit();
  }
}

  document.addEventListener("DOMContentLoaded", function() {
    // Check if the current path is /account/addresses
   if (window.location.pathname === '/account/addresses') {
     // Redirect to /account#address
     window.location.replace('/account#address');
   }
   });

   document.querySelectorAll('[data-confirm-message]').forEach(function (btn) {
  btn.addEventListener('click', function () {

    var confirmMsg = btn.dataset.confirmMessage || 'Are you sure you want to delete this address?';
    if (!window.confirm(confirmMsg)) return;

    var url = btn.dataset.target;
    
    var form = document.createElement('form');
    form.method = 'post';
    form.action = url;

    var methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'delete';

    var tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'authenticity_token';
    tokenInput.value = window.ShopifyAnalytics?.meta?.page?.csrf_token || document.querySelector('meta[name="csrf-token"]')?.content || '';

    form.appendChild(methodInput);
    form.appendChild(tokenInput);
    document.body.appendChild(form);
    form.submit();
  });
});

document.querySelectorAll('.btn-coupn-add, .btn-see-tracking').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('dashboard-content').style.display = 'none';
    document.getElementById('coupon-content').style.display = 'block';
  });
});

document.querySelectorAll('.btn-redeem-tracking').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('dashboard-content').style.display = 'none';
    document.getElementById('cashback-content').style.display = 'block';
  });
});

$.get('/apps/subscribfy-api/store/manage-membership-dashboard', function(resp) {
    var subscription = $('<div>').html(resp).find('.content-for-layout');
    $('#membership-content').html(subscription)

    if (window.exmCustomizeMembership) {
        window.exmCustomizeMembership();
    }
});

$.get('/apps/subscribfy-api/loyalty/store/dashboard', function(resp) {
    var dashboard = $('<div>').html(resp).find('.content-for-layout');
    // Store full content in hidden container (preserves CSS/scripts)
    $('.ch-hidden-data').html(dashboard);
    
    // Extract the specific elements from the stored data
    var redeemSection    = $('.ch-hidden-data').find('[x-data="redeem"]').clone();
    var couponsAvailable = $('.ch-hidden-data').find('#exm_coupons-available').clone();
    var pointsHistory    = $('.ch-hidden-data').find('#exm_points-history').clone();

    // ✅ Extract points AFTER ch-hidden-data is populated
    var rawPoints = parseInt($('.ch-hidden-data').find('.exison-points-value').text().trim(), 10) || 0;

    // Restructure each coupon card
    couponsAvailable.find('.exm_p-4').each(function() {
        var $card       = $(this);
        var $codeBlock  = $card.find('[x-data]').first();
        var $discount   = $card.find('.exm_mt-2');
        var $expires    = $card.find('.exm_text-gray-500');
        var $applyBtn   = $card.find('a.exm_loyalty-primary-btn');
        
        var discountText = $discount.find('b').text().trim();
        var parts        = discountText.split(' ');
        var amount       = parts[0];
        var label        = parts.slice(1).join(' ') || 'Discount';

        var $discountItem = $('<div class="ch-discount-item" style="order: 3;"></div>')
            .append($codeBlock)
            .append($applyBtn);

        var $innerCol = $card.find('.exm_flex.exm_flex-col.exm_gap-1').empty();
        $innerCol.append($discountItem);
        $innerCol.append($expires.attr('style', 'order: 2;'));
        $innerCol.append(
            $('<div style="order: 1;"></div>').html('<b>' + amount + '<br><h2>' + label + '</h2></b>')
        );

        $card.find('.exm_mt-3').remove();
        $card.wrap('<div class="ch-discount-container"></div>');
    });

    // ✅ Inject into DOM first
    $('.ch-coupon-codes').empty().append(redeemSection, couponsAvailable);
    $('.ch-point-history').empty().append(pointsHistory);

    // Dashboard tile: mirror only the wrapped discount cards into the
    // bare .ch-discount-container that lives inside .pre-dashboard-items
    // (no redeem section, no heading — just the coupon cards).
    var $dashCoupons = $('.pre-dashboard-items .ch-discount-container');
    if ($dashCoupons.length) {
        $dashCoupons.empty().append(couponsAvailable.find('.ch-discount-container').clone());
    }

    // ✅ Restructure point history AFTER it's in the DOM
    $('.ch-point-history').find('#exm_points-history').find('.exm_w-full').each(function() {
        var $group = $(this);

        $group.find('> span.exm_text-xl').first()
            .removeClass()
            .addClass('ch-ph-date')
            .css({
                'font-size': '13px',
                'font-weight': '600',
                'color': '#111',
                'display': 'block',
                'margin': '16px 0 6px'
            });

        $group.find('.exm_flex.exm_items-center.exm_justify-between').each(function() {
            var $row         = $(this);
            var $pointsBadge = $row.find('.exm_flex-shrink-0').last();
            var pointsText   = $pointsBadge.text().trim();
            var isDeduction  = pointsText.startsWith('-');

            var $iconWrap = $row.find('.exm_flex-shrink-0').first();
            var iconColor = isDeduction ? '#c0392b' : '#f4f4f4';
            var arrowSvg  = isDeduction
                ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 17L17 7M17 7H7M17 7V17" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 17H17M7 17V7" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

            $iconWrap
                .removeClass()
                .addClass('ch-ph-icon')
                .css({
                    'width': '36px',
                    'height': '36px',
                    'border-radius': '6px',
                    'background-color': iconColor,
                    'display': 'flex',
                    'align-items': 'center',
                    'justify-content': 'center',
                    'flex-shrink': '0'
                })
                .html(arrowSvg);

            var $textCol  = $row.find('.exm_flex.exm_flex-col');
            var titleText = $textCol.find('span').first().text().trim();
            $textCol.find('span').eq(1).remove();
            $textCol.find('span').first()
                .removeClass()
                .addClass('ch-ph-title')
                .text(titleText);

            $pointsBadge
                .removeClass()
                .addClass('ch-ph-points')
                .css({
                    'font-weight': '600',
                    'font-size': '14px',
                    'color': isDeduction ? '#e74c3c' : '#27ae60'
                })
                .text(pointsText);

            $row.removeClass().addClass('ch-ph-row').css({
                'display': 'flex',
                'align-items': 'center',
                'justify-content': 'space-between',
                'padding': '10px 0',
                'border-bottom': '1px solid #f0f0f0',
                'gap': '12px'
            });
        });
    });

    // ✅ Build points tracker AFTER rawPoints is extracted inside the callback
    buildPointsTracker(rawPoints);
    if (couponsAvailable.find('.exm_p-4').length) {
        $('.no-discount').hide();
        $('.ch-coupn-container').show();
    } else {
        $('.no-discount').show().append(redeemSection);
        $('.ch-coupn-container').hide();
    }
// ✅ Check rawPoints directly — already extracted inside $.get
    if (rawPoints === 0) {
        $('.cashback-point-history').show();
        $('.ch-cash-point-wraper').hide();
    } else {
        $('.cashback-point-history').hide();
        $('.ch-cash-point-wraper').show();
    }

    redeemSection.hide();
    $(document).on('click', '.ch-redeam-discount', function() {
        redeemSection.slideToggle(300);
    });
});

function buildPointsTracker(totalPoints) {
    var MILESTONE_VALUE  = 2000;
    var TOTAL_MILESTONES = 7;
    var $track = $('.ch-milestones-track').empty();
    // Update earned box
    $('.ch-points-number').text(totalPoints.toLocaleString());

    // Points away calculation
    var currentMilestone    = Math.floor(totalPoints / MILESTONE_VALUE);
    var remainder           = totalPoints % MILESTONE_VALUE;
    var nextMilestonePoints = currentMilestone < TOTAL_MILESTONES
        ? MILESTONE_VALUE - remainder
        : 0;
    $('.ch-points-away-num').text(nextMilestonePoints.toLocaleString());

    // Build each milestone item
    for (var i = 0; i < TOTAL_MILESTONES; i++) {
        var pointsForThisSlot = Math.min(Math.max(totalPoints - (i * MILESTONE_VALUE), 0), MILESTONE_VALUE);
        var fillPercent       = pointsForThisSlot / MILESTONE_VALUE;
        var isCenter          = (i === 0);
        var isActive          = fillPercent === 1;
        var isPartial         = fillPercent > 0 && fillPercent < 1;
        var radius       = isCenter ? 24 : 15;
        var circumference = 2 * Math.PI * radius;
        var dashOffset   = circumference - (fillPercent * circumference);
        var statusClass = isActive ? 'is-active' : (isPartial ? 'is-partial' : '');
        if (isCenter) statusClass += ' is-center';
        var circleSize = isCenter ? 56 : 36;
        var cx = circleSize / 2;
        var cy = circleSize / 2;
        var $item   = $('<div class="ch-milestone-item ' + statusClass + '"></div>');
        var $circle = $('<div class="ch-milestone-circle ' + (isActive || isPartial ? 'is-active' : '') + '"></div>');
        $circle.html(
            '<svg viewBox="0 0 ' + circleSize + ' ' + circleSize + '">' +
                '<circle class="ch-ring-bg" cx="' + cx + '" cy="' + cy + '" r="' + radius + '"/>' +
                '<circle class="ch-ring-fill" cx="' + cx + '" cy="' + cy + '" r="' + radius + '" ' +
                    'stroke-dasharray="' + circumference + '" ' +
                    'stroke-dashoffset="' + dashOffset + '"/>' +
            '</svg>' +
            (isCenter
                ? '<div class="ch-milestone-center-label"><span>' + totalPoints.toLocaleString() + '</span><span>Total Points</span></div>'
                : '<div class="ch-dot"></div>'
            )
        );
        var sublabel = isActive
            ? '<span class="ch-milestone-sublabel">Points</span>'
            : '<span class="ch-milestone-sublabel"><span class="ch-lock">🔒</span> Points</span>';
        $item.append($circle);
        $item.append('<span class="ch-milestone-label">2 000</span>');
        $item.append(sublabel);
        $track.append($item);
    }
}
